<template>
    <div v-if="client">
        <div class="field is-horizontal">
            <div class="field-label is-horizontal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.referralSettings.enabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Percent</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.referralSettings.percent" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Payout Min</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.referralSettings.payoutMin" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-horizontal">
                <label class="label">Game Providers</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p v-for="gameProvider in gameProviders" class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.referralSettings.gameProviders"
                                :id="gameProvider"
                                :value="gameProvider"
                                type="checkbox"
                            />
                            {{ gameProvider }}
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">FAQ content</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <content-string-ref
                            v-if="client.settings.referralSettings.faqContent"
                            :content-ref="client.settings.referralSettings.faqContent"
                            :delete-func="() => (client.settings.referralSettings.faqContent = null)"
                        />
                        <content-string-selector
                            v-else
                            :clientId="clientId"
                            :add-func="contentRef => (client.settings.referralSettings.faqContent = contentRef)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="saveAsync" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import state from '../../../../state';
import utils from '../../../../utils';

import clientService from '../../../../services/client.service';
import referralService from '../../../../services/referral.service';

import ContentStringRef from '../../../common/content/string/content-string-ref.vue';
import ContentStringSelector from '../../../common/content/string/content-string-selector.vue';

export default {
    name: 'client-settings-referral',
    components: { ContentStringRef, ContentStringSelector },
    data() {
        return {
            client: null,
            gameProviders: []
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
        this.loadGameProvidersAsync();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async loadGameProvidersAsync() {
            this.gameProviders.push(...(await referralService.getGameProvidersAsync()));
        },
        async saveAsync() {
            await clientService.save(this.client);
        }
    }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/referral.vue